import {
  buildAppDescription,
  buildAppUrl,
  buildMcpUrl,
  resolveAppDomain,
} from '@amitable/shared/app-config'
import { env } from '@/env'

export const appTitle = env.VITE_APP_TITLE
export const appDomain = resolveAppDomain(
  env.VITE_APP_DOMAIN,
  'VITE_APP_DOMAIN',
)
export const appUrl = buildAppUrl(appDomain)
export const mcpUrl = buildMcpUrl(appDomain)
export const appDescription = buildAppDescription(appTitle)

export { buildMcpUrl, buildAppUrl, resolveAppDomain }
